import { useTheme } from '@liquidweb-dev/undercurrent/styles';

const brandNameMap: Record<string, string> = {
	liquidweb: 'Liquid Web',
	nexcess: 'Nexcess',
};

const useBrandName = () => {
	const theme = useTheme();
	return (theme.name && brandNameMap[theme.name]) ?? 'Liquid Web';
};

export default useBrandName;
